import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorPage: React.FC<{ message?: string }> = ({ message }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-purple-100 p-6">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 flex flex-col items-center">
        {/* SVG Graphic */}
        <svg className="w-32 h-32 mb-6" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="100" fill="#f3f4f6"/>
          <path d="M60 120 Q100 160 140 120" stroke="#a78bfa" strokeWidth="8" strokeLinecap="round" fill="none"/>
          <circle cx="80" cy="90" r="10" fill="#6366f1"/>
          <circle cx="120" cy="90" r="10" fill="#6366f1"/>
          <ellipse cx="100" cy="100" rx="60" ry="80" fill="none" stroke="#818cf8" strokeWidth="4"/>
        </svg>
        <h1 className="text-3xl font-extrabold text-purple-700 mb-2">Oops! Something went wrong</h1>
        <p className="text-gray-600 mb-4 text-center">{message || 'An unexpected error occurred. Please try again or return home.'}</p>
        <button
          onClick={() => navigate('/')}
          className="mt-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-xl shadow-lg hover:from-blue-500 hover:to-purple-500 transition-all font-semibold"
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default ErrorPage; 